
"use client";

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import type { PubSubMessage } from "@/types";
import { Braces, FileText } from "lucide-react";

type MessageItemProps = {
  message: PubSubMessage;
};

export function MessageItem({ message }: MessageItemProps) {
  const isJson = message.dataType === 'json';
  const displayTimestamp = message.timestamp ? new Date(message.timestamp).toLocaleString() : 'N/A';

  return (
    <Card className="mb-4 shadow-md break-all">
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center text-lg">
          {isJson ? <Braces className="mr-2 h-5 w-5 text-accent" /> : <FileText className="mr-2 h-5 w-5 text-muted-foreground" />}
          Message ID: {message.id.substring(0, 8)}...
        </CardTitle>
        <CardDescription>
          Received: {displayTimestamp}
        </CardDescription>
      </CardHeader>
      <CardContent>
        {message.attributes && Object.keys(message.attributes).length > 0 && (
          <div className="mb-2">
            <h4 className="font-semibold text-sm">Attributes:</h4>
            <pre className="text-xs bg-muted p-2 rounded-md overflow-x-auto">
              {JSON.stringify(message.attributes, null, 2)}
            </pre>
          </div>
        )}
        <div>
          <h4 className="font-semibold text-sm">Data:</h4>
          {isJson ? (
            <pre className="text-sm bg-secondary p-3 rounded-md overflow-x-auto whitespace-pre-wrap">
              {typeof message.data === 'string' ? message.data : JSON.stringify(message.data, null, 2)}
            </pre>
          ) : (
            <p className="text-sm bg-secondary p-3 rounded-md whitespace-pre-wrap">
              {String(message.data)}
            </p>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
